<template>
    <div class="cp-form-wrap">
        <CurrentPartnerForm mode="create" :entities="entities" @created="onCreated" @close="$emit('close')" />
    </div>
</template>

<script>
import CurrentPartnerForm from "./form.vue";
export default {
    name: "current-partners-create",
    emits: ["created", "close"],
    props: ["entities"],
    components: { CurrentPartnerForm, },
    methods: {
        onCreated(msg) {
            this.$emit('created', msg);
        }
    },
}
</script>

<style scoped>
.cp-form-wrap {
    display: flex;
    flex-direction: column;
    width: 100%;
    min-height: 100%;
}
</style>